import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "stockDisplay", "useStock", "variant"]
  static values = {
    objectId: Number,
    objectType: String
  }

  connect() {
    this.updateStock()
  }

  updateStock() {
    const quantity = parseInt(this.quantityTarget.value) || 1
    const variantId = this.hasVariantTarget ? this.variantTarget.value : null

    if (!variantId) {
      this.stockDisplayTarget.innerHTML = '<p class="text-muted text-center">No variant selected</p>'
      return
    }

    fetch(`/crafting/${this.objectTypeValue}/${this.objectIdValue}/calculate_stock?quantity=${quantity}&variant_id=${variantId}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.stockDisplayTarget.innerHTML = data.html
    })
    .catch(error => {
      console.error('Error fetching stock:', error)
    })
  }
}

